<script lang="ts">
  import { FirebaseFunctionsLocation } from '../../Firebase'
  import { user_token } from '../../Users/observables'
  import NavigationButton from './NavigationButton.svelte'
  let form: HTMLFormElement
</script>

<form
  bind:this={form}
  method="post"
  action={`${FirebaseFunctionsLocation}redirectToCustomerPortal`}
  target="_blank"
>
  <input name="token" value={$user_token} type="hidden" />
  <NavigationButton
    onClick={() => {
      console.log('submitting...')
      form.submit()
    }}
    destination="external">Manage Subscription</NavigationButton
  >
</form>

<style>
  form {
    display: inline;
  }
</style>
